import { FC, useEffect } from 'react'
import { useStores } from '@/utils'
import { MessageType, IQuestionBase } from '@/types'
import { observer } from 'mobx-react'
import { EditAndDeleteButtons } from '@/components/atoms/EditAndDeleteButtons'
import router from 'next/router'
import { QuestionBoxQuestionerGroup } from '@/components/molecules/QuestionBoxQuestionerGroup'
import { PollBoxBody } from '@/components/molecules/PollBoxBody'
import styles from './index.module.scss'

type Props = {
  question: IQuestionBase
}

export const PollBox: FC<Props> = observer(({ question }) => {
  const { messages, viewer, questions } = useStores()
  const isDeletable = question.questioner.username === viewer.viewer?.username
  const pollInstance = questions.createQuestionInstance(question)

  // ブラウザ側での初期化時に question を取得
  useEffect(() => {
    if (!question || !pollInstance) {
      return
    }

    if (viewer.isInitialized && viewer.isSignedIn) {
      // Answers は20件だけ取得（Gateway 参照）。もし、Answers の数が多いようなら Load more を実装する。
      pollInstance.fetch()
    }
  }, [viewer.isInitialized, question])

  const onClickDelete = async (id: string) => {
    // eslint-disable-next-line no-alert
    if (window.confirm('Are you sure to delete this post?')) {
      const isSuccessful = await viewer.viewer.removeMyQuestion(id)
      if (isSuccessful) {
        messages.add({
          type: MessageType.Info,
          body: 'Your post deleted.',
          isTranslated: true,
          ttl: 5000,
        })
      }
      router.push('/')
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <div className={styles.categoryGroup}>
          <div className={styles.type}>Poll</div>
          <div className={styles.category}>#{pollInstance?.questionCategory.name}</div>
        </div>
        {isDeletable && <EditAndDeleteButtons onClickDelete={() => onClickDelete(pollInstance.id)} isDeleteOnly />}
      </div>
      <PollBoxBody pollInstance={pollInstance} />
      <QuestionBoxQuestionerGroup question={question} />
    </div>
  )
})
